import { render, staticRenderFns } from "./transferStock.vue?vue&type=template&id=5d87c7a6"
import script from "./transferStock.vue?vue&type=script&lang=js"
export * from "./transferStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports